import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Assistant from "./pages/Assistant";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Assistant />} />
        <Route path="/assistant" element={<Assistant />} />
      </Routes>
    </Router>
  );
}

export default App;
